import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';

const RECORDING_UPLOAD_TIMEOUT = 30000; // 30 seconds to allow uploads of up to 10MB

export default class RecordingsGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/configuration/ivr-recordings/:id');
  }

  add(params, data) {
    const url = this.endpoint.set(params).addUrl;

    return this.http
      .post(url, data, {
        timeout: RECORDING_UPLOAD_TIMEOUT,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(dto => this.observer.onAddSuccess(dto, params))
      .catch(error => this.observer.onAddError(error, params));
  }
}
